import { Fragment } from "react";
import "./NFTMarketplace.css";
import { nftMarketplace } from "../../staticdata";
import nftmarketplacebanner from "../../assets/images/services/nft/nftmarketplacebanner.jpg";

const NFTMarketplace = () => {
  return (
    <Fragment>
      <section className="nftmarketplace-style">
        <div className="nftmarketplace-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="nftmarketplace-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  NFT Marketplace Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Kairaa – your trusted partner for crafting NFT solutions that
                  stand out in the digital landscape. With our NFT development
                  services, we are here to transform your vision into a
                  feature-rich and flawlessly executed NFT marketplace. Let’s
                  Discuss.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={nftmarketplacebanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="nftmarketplace-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">NFT Marketplace Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {nftMarketplace.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="nftmarketplace-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default NFTMarketplace;
